module.exports = __webpack_public_path__ + "static/img/logo.4f85d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/logo.png
// module id = s68h
// module chunks = 1